import {
  genericCreate,
  genericFind,
  genericGet,
  genericRemove,
} from '@/services/common';

import update from './update';

export const create = genericCreate('component');

export const find = genericFind('component');

export const get = genericGet('component');

export const remove = genericRemove('component');

export * from './types';

export default {
  create,
  find,
  get,
  remove,
  update,
};
